<template>
  <div class="order-record-page">
    <!-- 标签栏 -->
    <div class="tab-bar">
      <button class="tab-btn" :class="{ active: activeTab === 'all' }" @click="handleTabChange('all')">
        全部记录
      </button>
      <button class="tab-btn" :class="{ active: activeTab === 'purchased' }" @click="handleTabChange('purchased')">
        已支付
      </button>
      <button class="tab-btn" :class="{ active: activeTab === 'pending' }" @click="handleTabChange('pending')">
        待支付
      </button>
      <button class="tab-btn" :class="{ active: activeTab === 'failed' }" @click="handleTabChange('failed')">
        交易失败
      </button>
      <button class="tab-btn" :class="{ active: activeTab === 'afterSale' }" @click="handleTabChange('afterSale')">
        售后中
      </button>
    </div>

    <!-- 搜索栏 -->
    <div class="search-bar">
      <input type="text" class="search-input" placeholder="请输入搜索内容" v-model="searchKeyword">
      <button class="search-btn1" @click="handleSearch">搜索</button>
      <button class="reset-btn" @click="handleReset">重置</button>
    </div>

    <!-- 订单列表 -->
    <div class="order-list">
      <div class="order-header">
        <span style="margin-right: 680px;">模型信息</span>
        <span style="margin-right: 140px;">模型价格(云币)</span>
        <span style="margin-right: 160px;">交易状态</span>
        <span style="margin-right: 150px;">实付款(云币)</span>
        <span>交易操作</span>
      </div>

      <!-- 空数据提示 -->
      <div class="empty-tip" v-if="MyOrderList.length === 0">
        暂无相关订单数据
      </div>

      <!-- 订单列表循环渲染 -->
      <div class="order-item" v-for="order in MyOrderList" :key="order.orderid">
        <div class="order-meta">
          <span>订单号：{{ order.orderid }}</span>
          <span>支付单号：{{ order.paymentNumber || '----' }}</span>
          <span>创建时间：{{ order.creationTime }}</span>
          <span>付款时间：{{ order.paymentTime || '----' }}</span>
        </div>
        <div class="order-content">
          <div class="model-img-wrapper">
            <!-- 失效标签 -->
            <div class="model-status" v-if="order.modelStatus === '失效'">失效</div>
            <img :src="order.previewUrl" class="model-img">
          </div>
          <div class="model-info">
            <div class="model-name">{{ order.title }}</div>
            <div class="model-uploader">作者：{{ order.userName }}</div>
          </div>
          <div class="model-price">{{ order.orderAmount }}</div>
          <div class="order-status">
            <span :class="getStatusClass(order.transactionStatus)">{{ order.transactionStatus }}</span>
            <!-- 倒计时仅待支付显示 -->
            <div class="countdown" v-if="order.transactionStatus === '待支付'">
              <!-- 显示计算后的倒计时 -->
              {{ order.countdownText || '订单已超时' }}
            </div>
          </div>
          <div class="actual-payment">{{ order.amountPaid || '----' }}</div>
          <div class="order-actions">
            <button class="pay-btn" @click="openPayConfirmModal(order)" 
                    v-if="order.transactionStatus === '待支付' && order.countdownText">
              立即付款
            </button>
            <div class="action-item" @click="getCancelMyOrder(order.orderid)" 
                 v-if="order.transactionStatus === '待支付' && order.countdownText">
              取消订单
            </div>
            <div class="action-item" @click="getDelMyOrder(order.orderid)">
              删除订单
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ElementUI 分页组件 -->
    <div class="pagination-container" v-if="total > 0">
      <el-pagination @current-change="handleCurrentChange" :current-page="pageIndex" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </div>

    <!-- 付款二次确认弹窗（复用购物车样式） -->
    <div class="pay-confirm-modal" v-if="showPayModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>确认付款</h3>
          <span class="close-btn" @click="closePayConfirmModal">&times;</span>
        </div>
        <div class="modal-body">
          <div class="total-info">
            <span>应付总额：</span>
            <span class="total-price">{{ currentOrder.orderAmount.toFixed(2) }}云币</span>
          </div>
          <div class="models-info">
            <p class="info-title">已选择1个模型</p>
            <div class="models-list">
              <div class="model-item-mini">
                <img :src="currentOrder.previewUrl" :alt="currentOrder.title" class="mini-img">
                <div class="mini-info">
                  <div class="mini-name">{{ currentOrder.title || '未命名模型' }}</div>
                  <div class="mini-price">价格：{{ currentOrder.orderAmount.toFixed(2) }}云币</div>
                </div>
              </div>
            </div>
          </div>
          <div class="doc">
            <span>购买前请确认授权类型及金额，确认购买即视为您已阅读并同意
              <a href="javascript:void(0)" class="discount-tag" @click="openBuyerAgreement">《智步云上模型网买家协议》</a>
              与
              <a href="javascript:void(0)" class="discount-tag" @click="openLicenseAgreement">《智步云上模型网授权协议》</a>
            </span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="closePayConfirmModal">取消</button>
          <button class="confirm-btn" @click="confirmPay">确认付款</button>
        </div>
      </div>
    </div>
    <!-- 弹窗遮罩层 -->
    <div class="modal-mask" v-if="showPayModal" @click="closePayConfirmModal"></div>
  </div>
</template>

<script>
export default {
  name: 'OrderRecordPage',
  data() {
    return {
      activeTab: 'all',
      MyOrderList: [],
      searchKeyword: '',
      pageIndex: 1,
      pageSize: 4,
      total: 0,
      countdownTimer: null, // 倒计时定时器
      // 付款弹窗相关
      showPayModal: false,
      currentOrder: {} // 当前待付款订单
    };
  },
  created() {
    this.getMyOrder();
  },
  mounted() {
    // 启动每秒倒计时
    this.startCountdownTimer();
  },
  beforeDestroy() {
    // 页面销毁清定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    // 打开买家协议
    openBuyerAgreement() {
      window.open('/#/protocol/buyer-doc', '_blank');
    },
    // 打开授权协议
    openLicenseAgreement() {
      window.open('/#/protocol/license-doc', '_blank');
    },
    // 启动全局倒计时
    startCountdownTimer() {
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.countdownTimer = setInterval(() => {
        this.updateAllOrderCountdown();
      }, 1000);
    },

    // 计算单个订单倒计时：创建时间 +24小时
    calculateCountdown(creationTime) {
      if (!creationTime) return null;
      const create = new Date(creationTime).getTime();
      const now = Date.now();
      const validMs = 24 * 60 * 60 * 1000; // 24小时有效期
      const expire = create + validMs;
      const left = expire - now;

      if (left <= 0) return null;

      const h = Math.floor(left / 3600000);
      const m = Math.floor((left % 3600000) / 60000);
      const s = Math.floor((left % 60000) / 1000);

      const f = n => n.toString().padStart(2, '0');
      return `剩余${f(h)}时${f(m)}分${f(s)}秒`;
    },

    // 刷新所有订单倒计时
    updateAllOrderCountdown() {
      if (!this.MyOrderList.length) return;
      let needRefresh = false;

      this.MyOrderList = this.MyOrderList.map(order => {
        if (order.transactionStatus === '待支付') {
          const old = order.countdownText;
          const txt = this.calculateCountdown(order.creationTime);
          if (old && !txt) needRefresh = true; // 有订单超时
          return { ...order, countdownText: txt };
        }
        return order;
      });

      // 超时自动刷新列表拿最新状态
      if (needRefresh) {
        this.getMyOrder();
      }
    },

    // ========== 真实接口：获取订单列表 ==========
    getMyOrder() {
      const tabToStatusMap = {
        all: '',
        purchased: '已支付',
        pending: '待支付',
        failed: '交易失败',
        afterSale: '售后中'
      };

      const params = {
        transactionStatus: tabToStatusMap[this.activeTab],
        title: this.searchKeyword.trim(),
        start: '',
        end: '',
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };

      this.$apiFun.getMyOrder(params)
        .then(res => {
          if (res.status === 200) {
            // 给每个待支付订单绑定倒计时
            this.MyOrderList = (res.obj || []).map(order => ({
              ...order,
              countdownText: order.transactionStatus === '待支付'
                ? this.calculateCountdown(order.creationTime)
                : ''
            }));
            this.total = res.num || 0;
          }
        })
        .catch(err => {
          console.error('订单加载失败', err);
          this.$message.error('订单加载失败，请稍后重试');
        });
    },

    // 取消订单
    getCancelMyOrder(orderId) {
      this.$confirm('确定取消该订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.$apiFun.getCancelMyOrder({ orderid: orderId });
      }).then(res => {
        if (res.status === 200) {
          this.$message.success('订单取消成功');
          this.getMyOrder();
        }
      }).catch(() => {});
    },

    // 删除订单
    getDelMyOrder(orderId) {
      this.$confirm('确定删除？删除后无法恢复！', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        return this.$apiFun.getDelMyOrder({ orderid: orderId });
      }).then(res => {
        if (res.status === 200) {
          this.$message.success('删除成功');
          this.getMyOrder();
        }
      }).catch(() => {});
    },

    // 切换标签
    handleTabChange(tab) {
      this.activeTab = tab;
      this.pageIndex = 1;
      this.getMyOrder();
    },

    // 搜索
    handleSearch() {
      this.pageIndex = 1;
      this.getMyOrder();
    },

    // 重置
    handleReset() {
      this.searchKeyword = '';
      this.activeTab = 'all';
      this.pageIndex = 1;
      this.getMyOrder();
    },

    // 状态样式
    getStatusClass(status) {
      const cls = {
        '已支付': 'paid',
        '待支付': 'pending',
        '交易失败': 'failed',
        '售后中': 'after-sale'
      };
      return cls[status] || '';
    },

    // 打开付款确认弹窗
    openPayConfirmModal(order) {
      this.currentOrder = order;
      this.showPayModal = true;
    },

    // 关闭付款确认弹窗
    closePayConfirmModal() {
      this.showPayModal = false;
      this.currentOrder = {};
    },

    // 确认付款（调用购物车同款付款接口）
    confirmPay() {
      // 构造与购物车一致的请求参数
      const modelIdList = [this.currentOrder.modelId];
      const priceList = [this.currentOrder.orderAmount];

      this.$apiFun.postBuyNows({ 
        modelId: modelIdList, 
        amounts: priceList 
      }).then(res => {
        if (res.status === 200) {
          this.$message.success("模型购买成功！您可以立即下载");
          this.closePayConfirmModal();
          this.getMyOrder(); // 付款成功后刷新订单列表
        } else if (res.status === 888) {
          this.$message.warning("账户余额不足，请先充值后再试");
        } else {
          this.$message.error(`购买失败：${res.message || '未知错误'}`);
        }
      }).catch(err => {
        console.error('订单付款失败:', err);
        this.$message.error('付款操作异常，请稍后重试');
      });
    },

    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getMyOrder();
    }
  }
};
</script>

<style lang="less" scoped>
// 深色主题基础变量
@bg-primary: #1e1e1e;
@bg-secondary: #080a12;
@text-primary: #e0e0e0;
@text-secondary: #a0a0a0;
@accent-blue: #0ea5e9;
@accent-green: #4caf50;
@accent-red: #ef4444;
@accent-orange: #f97316;
@border-color: #424242;
@hover-bg: rgba(255, 255, 255, 0.1);

.order-record-page {
  color: @text-primary;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;

  // 标签栏样式
  .tab-bar {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid @border-color;
    margin-bottom: 20px;
    gap: 5px;

    .tab-btn {
      padding: 10px 20px;
      background-color: transparent;
      border: none;
      color: @text-secondary;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.3s;
      border-bottom: 2px solid transparent;
      white-space: nowrap;

      &.active {
        color: @accent-blue;
        border-bottom: 2px solid @accent-blue;
        font-weight: 500;
      }

      &:hover {
        color: @text-primary;
      }
    }
  }

  // 搜索栏样式
  .search-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;

    .search-input {
      color: @text-primary;
      border: 1px solid @border-color;
      padding: 8px 12px;
      border-radius: 4px;
      width: 180px;
      background-color: @bg-primary;
    }

    .search-btn1 {
      background-color: @accent-blue;
      color: #fff;
      border: none;
      padding: 8px 20px;
      border-radius: 4px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: darken(@accent-blue, 10%);
      }
    }

    .reset-btn {
      background-color: transparent;
      color: @text-primary;
      border: 1px solid @border-color;
      padding: 8px 20px;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background-color: @hover-bg;
      }
    }
  }

  // 订单列表样式
  .order-list {
    .order-header {
      padding: 12px 20px;
      font-size: 14px;
      color: @text-secondary;
      border-radius: 8px 8px 0 0;
      font-weight: 500;
      background-color: @bg-secondary;
    }

    .empty-tip {
      padding: 40px;
      text-align: center;
      color: @text-secondary;
      background-color: @bg-secondary;
      border-radius: 8px;
      font-size: 14px;
    }

    .order-item {
      background-color: @bg-secondary;
      margin-bottom: 12px;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

      .order-meta {
        padding: 12px 20px;
        font-size: 12px;
        color: @text-secondary;
        border-bottom: 1px solid @border-color;
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
      }

      .order-content {
        display: flex;
        padding: 15px 20px;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;

        .model-img-wrapper {
          position: relative;
          margin-right: 15px;
        }

        .model-status {
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.7);
          color: #fff;
          font-size: 12px;
          padding: 2px 6px;
          border-radius: 4px 0 4px 0;
        }

        .model-img {
          width: 80px;
          height: 80px;
          object-fit: cover;
          border-radius: 4px;
        }

        .model-info {
          min-width: 500px;

          .model-name {
            font-size: 14px;
            margin-bottom: 5px;
            font-weight: 500;
          }

          .model-uploader {
            font-size: 12px;
            color: @text-secondary;
          }
        }

        .model-price,
        .actual-payment {
          min-width: 300px;
          text-align: center;
          font-size: 14px;
        }

        .actual-payment {
          color: @accent-green;
          font-weight: 500;
        }

        .order-status {
          min-width: 120px;
          text-align: center;

          .pending {
            color: @accent-orange;
          }

          .paid {
            color: @accent-green;
          }

          .failed {
            color: @accent-red;
          }

          .after-sale {
            color: @accent-blue;
          }

          .countdown {
            font-size: 12px;
            color: @accent-orange; // 倒计时文字改为橙色，更醒目
            margin-top: 5px;
            font-weight: 500;
          }
        }

        .order-actions {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          min-width: 100px;

          .pay-btn {
            background-color: @accent-blue;
            color: #fff;
            border: none;
            padding: 8px 20px;
            border-radius: 4px;
            cursor: pointer;
            transition: background-color 0.3s;

            &:hover {
              background-color: darken(@accent-blue, 10%);
            }

            &:disabled {
              background-color: #4a4a4a;
              cursor: not-allowed;
              opacity: 0.7;
            }
          }

          .action-item {
            font-size: 12px;
            color: @text-secondary;
            cursor: pointer;
            padding: 4px 8px;
            border-radius: 4px;
            transition: all 0.3s;

            &:hover {
              color: @text-primary;
              background-color: @hover-bg;
            }
          }
        }
      }
    }
  }

  // 分页组件样式
  .pagination-container {
    margin-top: 30px; // 增加间距，视觉更友好
    display: flex;
    justify-content: center; // 水平居中核心
    align-items: center; // 垂直居中，避免错位
    padding: 10px 0;
  }

  // 核心：修改分页组件的背景色、字体色
  :deep(.el-pagination) {
    // 1. 分页组件整体背景色（如果需要）
    background-color: transparent !important; // 透明，继承页面深色背景

    // 2. 总条数文字颜色
    .el-pagination__total {
      color: #e0e0e0 !important; // 浅色文字，适配深色背景
      font-size: 14px !important; // 可选：调整字体大小
    }

    // 3. 页码按钮样式
    .el-pager {
      li {
        // 未选中页码的样式
        background-color: #080a12 !important; // 深色背景
        color: #a0a0a0 !important; // 次要文字色
        border: 1px solid #424242 !important; // 边框色
        margin: 0 2px !important; // 页码间距

        // 页码 hover 效果
        &:hover {
          background-color: rgba(255, 255, 255, 0.1) !important;
          color: #0ea5e9 !important; // 高亮蓝色
          border-color: #0ea5e9 !important;
        }

        // 当前选中页码的样式
        &.active {
          background-color: #0ea5e9 !important; // 主色背景
          color: #ffffff !important; // 白色文字
          border-color: #0ea5e9 !important;
        }
      }
    }

    // 4. 上一页/下一页按钮样式
    .btn-prev,
    .btn-next {
      background-color: @bg-secondary !important;
      color: @text-secondary !important;
      border: 1px solid @border-color !important;
      min-width: 30px !important;
      margin: 0 2px !important;

      // 禁用状态
      &.disabled {
        background-color: darken(@bg-secondary, 5%) !important;
        color: darken(@text-secondary, 20%) !important;
        border-color: darken(@border-color, 10%) !important;
        cursor: not-allowed !important;

        &:hover {
          background-color: darken(@bg-secondary, 5%) !important;
          color: darken(@text-secondary, 20%) !important;
          border-color: darken(@border-color, 10%) !important;
        }
      }

      // 正常状态 hover
      &:not(.disabled):hover {
        background-color: @hover-bg !important;
        color: @accent-blue !important;
        border-color: @accent-blue !important;
      }

      // 图标样式
      .el-icon {
        font-size: 12px !important;
        font-weight: bold !important;
      }
    }

    // 5. 跳转页码输入框样式
    .el-pagination__jump {
      color: #a0a0a0 !important; // 文字色

      .el-input__inner {
        background-color: #080a12 !important; // 输入框背景
        color: #e0e0e0 !important; // 输入框文字色
        border: 1px solid #424242 !important; // 输入框边框

        &:focus {
          border-color: #0ea5e9 !important; // 聚焦边框色
        }
      }
    }
  }

  // 付款确认弹窗样式（复用购物车样式）
  .pay-confirm-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1001;
    width: 500px;
    max-width: 90vw;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
    overflow: hidden;

    .modal-content {
      background-color: @bg-primary;
      width: 100%;
    }

    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
      border-bottom: 1px solid @border-color;
      background-color: @bg-primary;

      h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
      }

      .close-btn {
        font-size: 20px;
        cursor: pointer;
        color: @text-secondary;

        &:hover {
          color: @text-primary;
        }
      }
    }

    .modal-body {
      padding: 20px;
      max-height: 60vh;
      overflow-y: auto;
      background-color: @bg-primary;
      box-sizing: border-box;

      .total-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 15px;
        border-bottom: 1px solid @border-color;
        margin-bottom: 15px;

        .total-price {
          font-size: 18px;
          color: @accent-blue;
          font-weight: 500;
        }
      }

      .models-info {
        .info-title {
          font-size: 14px;
          margin-bottom: 10px;
          color: @text-secondary;
        }

        .models-list {
          display: flex;
          flex-direction: column;
          gap: 10px;

          .model-item-mini {
            display: flex;
            align-items: center;
            padding: 10px;
            background-color: @bg-secondary;
            border-radius: 4px;

            .mini-img {
              width: 60px;
              height: 60px;
              object-fit: cover;
              border-radius: 4px;
              margin-right: 10px;
              flex-shrink: 0;
            }

            .mini-info {
              flex: 1;
              min-width: 0;

              .mini-name {
                font-size: 14px;
                margin-bottom: 5px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .mini-price {
                font-size: 12px;
                color: @accent-blue;
              }
            }
          }
        }
      }

      .doc {
        font-size: 12px;
        margin: 15px 0;
        cursor: pointer;
        line-height: 1.4;
        color: @text-secondary;

        .discount-tag {
          color: #ffb042;
          text-decoration: none;
          margin: 0 3px;
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      padding: 15px 20px;
      border-top: 1px solid @border-color;
      background-color: @bg-primary;

      .cancel-btn {
        padding: 8px 16px;
        background-color: transparent;
        border: 1px solid @border-color;
        color: @text-primary;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
          background-color: #2a2a2a;
        }
      }

      .confirm-btn {
        padding: 8px 16px;
        background-color: @accent-blue;
        color: #fff;
        border: none;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }

  // 弹窗遮罩层
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
}

// 响应式适配
@media (max-width: 768px) {
  .order-record-page {
    padding: 10px;

    .search-bar {
      .search-input {
        width: 100%;
      }
    }

    .order-list {
      .order-content {
        flex-direction: column;
        align-items: flex-start;

        .model-img-wrapper {
          margin-right: 0;
          margin-bottom: 10px;
        }

        .model-info,
        .model-price,
        .order-status,
        .actual-payment {
          width: 100%;
          text-align: left;
          margin-bottom: 8px;
        }

        .order-actions {
          width: 100%;
          flex-direction: row;
          justify-content: flex-start;
        }
      }
    }

    // 分页组件响应式
    .pagination-container {
      :deep(.el-pagination) {
        justify-content: center;
        flex-wrap: wrap;

        .btn-prev,
        .btn-next {
          margin: 2px !important;
        }

        .el-pager li {
          margin: 2px !important;
        }
      }
    }

    // 弹窗响应式
    .pay-confirm-modal {
      max-width: 95vw;

      .modal-header {
        padding: 10px 15px;

        h3 {
          font-size: 14px;
        }
      }

      .modal-body {
        padding: 15px 10px;
        max-height: 50vh;

        .total-info {
          padding-bottom: 10px;
          margin-bottom: 10px;

          .total-price {
            font-size: 16px;
          }
        }

        .model-item-mini {
          padding: 8px;

          .mini-img {
            width: 50px;
            height: 50px;
            margin-right: 8px;
          }
        }
      }

      .modal-footer {
        padding: 10px 15px;
        justify-content: center;

        .cancel-btn, .confirm-btn {
          padding: 6px 12px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>